// src/redux/reducers/wishlistReducer.js

import {
  WISHLIST_REQUEST,
  WISHLIST_SUCCESS,
  WISHLIST_FAILURE,
  ADD_WISHLIST_SUCCESS,
  DELETE_WISHLIST_SUCCESS,
} from "../actions/wishlistAction";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case WISHLIST_REQUEST:
      return { ...state, loading: true, error: null };

    case WISHLIST_SUCCESS:
      return { ...state, loading: false, items: action.payload };

    case ADD_WISHLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        items: [...state.items, action.payload],
      };

    case DELETE_WISHLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        items: state.items.filter(item => item.id !== action.payload),
      };

    case WISHLIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default wishlistReducer;
